import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// Components
import Modal from '../../Components/Modal';
import Header from '../../Components/Header';
import FormData from '../../Components/FormData';
import Container from '../../Components/Container';
// Services
import { createInstitution } from '../../Services/createInstitution';
import { availableCategories } from '../../Services/getCategories';
// Styles
import './AdminPage.css';
import { resourcesCategories } from './constants';

const AdminPage = () => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!localStorage.name || !localStorage.email) {
			navigate('/');
		}
	}, [navigate]);

	const [institutionType, setInstitutionType] = useState([]);
	const [categories, setCategories] = useState([]);
	const [name, setName] = useState('');
	const [code, setCode] = useState('');
	const [domain, setDomain] = useState('');
	const [logo, setLogo] = useState(null);
	const [modal, setModal] = useState(false);
	const [error, setError] = useState('');
	const [requestLoginInstitution, setRequestLoginInstitution] = useState(false);
	const [uniqueLoginInstitution, setUniqueLoginInstitution] = useState(false);
	const [uniqueUser, setUniqueUser] = useState('');
	const [uniqueUserPass, setUniqueUserPass] = useState('');
	const [selectedResourcesCategories, setSelectedResourcesCategories] =
		useState([]);
	// Estados para la creación de institución
	const [loading, setLoading] = useState(false);
	const [messageCreation, setMessageCreation] = useState(false);

	// Función para seleccionar el tipo de institución
	const changeInstitutionType = (type) => {
		if (institutionType.includes(type)) {
			setInstitutionType(institutionType.filter((value) => value !== type));
		} else {
			setInstitutionType([...institutionType, type]);
		}
	};

	// Función para selección de categorias
	const categoriesSelected = (optionValue) => {
		if (categories.includes(optionValue)) {
			setCategories(categories.filter((value) => value !== optionValue));
		} else {
			if (categories.length >= 4) {
				activateModal('Maximo de categorías permitidas: 4');
			} else {
				setCategories([...categories, optionValue]);
			}
		}
	};

	// Funcion de manejador del modal
	const activateModal = (message) => {
		setError(message);
		setModal(true);
		setTimeout(() => {
			setModal(false);
			setError('');
		}, 2000);
	};

	// Función del formulario
	const handleSubmit = (e) => {
		e.preventDefault();

		createInstitution(
			name,
			institutionType,
			code,
			domain,
			logo,
			categories,
			activateModal,
			requestLoginInstitution,
			uniqueLoginInstitution,
			uniqueUser,
			uniqueUserPass,
			setLoading,
			setMessageCreation,
			selectedResourcesCategories
		);
	};

	const handleCheckboxChange = (category) => {
		setSelectedResourcesCategories((prev) =>
			prev.includes(category)
				? prev.filter((item) => item !== category)
				: [...prev, category]
		);
	};
	return (
		<>
			<Header />
			{modal && <Modal message={error} setModal={setModal} />}
			<h1 className=' text-center text-3xl font-bold pt-8 pb-12'>
				ADMIN PANEL
			</h1>
			<Container>
				<main>
					<form onSubmit={handleSubmit} className='form'>
						<section className='formSection'>
							<h2>Institution name</h2>
							<input
								required={true}
								type='text'
								placeholder='University of Florida'
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
						</section>

						<section className='formSection'>
							<h2>Institution code</h2>
							<input
								required={true}
								type='text'
								placeholder='UOF'
								value={code}
								onChange={(e) => setCode(e.target.value)}
							/>
						</section>

						<section className='formSection'>
							<h2>Dominio (url) de la institución</h2>
							<input
								required={true}
								type='text'
								placeholder='library.com'
								value={domain}
								onChange={(e) => setDomain(e.target.value)}
							/>
						</section>

						<section className='formSection'>
							<h2>Tipo de institución</h2>
							<div className='formSectionCategories'>
								<div>
									<input
										type='checkbox'
										checked={institutionType.medicine}
										value={institutionType.medicine}
										onChange={() => changeInstitutionType('medicine')}
									/>
									<p>Medicine</p>
								</div>
								<div>
									<input
										type='checkbox'
										checked={institutionType.technology}
										value={institutionType.technology}
										onChange={() => changeInstitutionType('technology')}
									/>
									<p>Technology</p>
								</div>
							</div>
						</section>

						<section className='formSection'>
							<h2>Login para la institución</h2>
							<div className='formSectionCategories'>
								<div>
									<input
										type='checkbox'
										checked={requestLoginInstitution}
										value={requestLoginInstitution}
										onChange={() =>
											setRequestLoginInstitution(!requestLoginInstitution)
										}
									/>
									<p>Requiere login (Canvas, Moodle, Talent, etc..)</p>
								</div>
								<div>
									<input
										type='checkbox'
										checked={uniqueLoginInstitution}
										value={uniqueLoginInstitution}
										onChange={() => {
											setUniqueLoginInstitution(!uniqueLoginInstitution);
											setRequestLoginInstitution(!uniqueLoginInstitution);
										}}
									/>
									<p>Requiere login unico</p>
								</div>
							</div>
							{uniqueLoginInstitution && (
								<div className='uniqueUserContainer'>
									<label>
										User:
										<input
											type='text'
											name='name'
											value={uniqueUser}
											onChange={(e) => setUniqueUser(e.target.value)}
										/>
									</label>
									<label>
										Pass:
										<input
											type='text'
											name='name'
											value={uniqueUserPass}
											onChange={(e) => setUniqueUserPass(e.target.value)}
										/>
									</label>
								</div>
							)}
						</section>

						<section className='formSection'>
							<h2>Logo de la institución (.png)</h2>
							<FormData setLogo={setLogo} logo={logo} />
						</section>

						{availableCategories && (
							<section>
								<h2 className='text-xl font-medium text-center my-4 mb-10'>
									Categorias de institución
								</h2>

								<div className='categoryContainer'>
									{availableCategories.map((element, i) => {
										return (
											<div className='categorie' key={i}>
												<input
													checked={
														categories.includes(element.name) ? true : false
													}
													type='checkbox'
													value={element.name}
													onChange={() => {
														categoriesSelected(element.name);
													}}
												/>
												<img
													src={element.url}
													alt={element.name}
													loading='lazy'
												/>
												<p>{element.name.replaceAll('-', ' ')}</p>
											</div>
										);
									})}
								</div>
							</section>
						)}

						<section>
							<div>
								<h2 className='text-xl font-medium text-center my-4 mb-10'>
									Categorias de los recursos
								</h2>
								<div className='flex flex-wrap gap-6 gap-y-8'>
									{resourcesCategories.map((category) => (
										<div key={category}>
											<label className='p-3 bg-white rounded-md shadow-md cursor-pointer'>
												<input
													type='checkbox'
													checked={selectedResourcesCategories.includes(
														category
													)}
													onChange={() => handleCheckboxChange(category)}
												/>
												<span className='pl-2'>{category}</span>
											</label>
										</div>
									))}
								</div>
							</div>
						</section>
						{loading ? (
							<div className='loadingContainer'>
								<p>Creando institución...</p>
								<span className='loading'></span>
							</div>
						) : (
							<button type='submit' className='sendButton'>
								Crear institución
							</button>
						)}
						{messageCreation && (
							<div className='loadingContainer'>
								<p>{messageCreation}</p>
							</div>
						)}
					</form>
				</main>
			</Container>
		</>
	);
};

export default AdminPage;
